import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

// Attach admin token if present
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("cbc_admin_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export const fmtUSD = (n) =>
    new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
    }).format(Number(n || 0));
